// extracted by mini-css-extract-plugin
export var button = "counter-module--button--ssUzt";
export var counter = "counter-module--counter--pWQmy";
export var number = "counter-module--number--0M3u7";